import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import PasswordInput from "../components/PasswordInput";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login({ email, password });
    setLoading(false);
    if (r.ok) {
      toast.success("Bentornato!");
      navigate(r.user.is_admin ? "/admin" : r.user.role === "supplier" ? "/fornitore" : "/ristorante");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="ga-card p-8" data-testid="login-card">
        <h1 className="font-display text-3xl font-bold text-slate-900">Accedi</h1>
        <p className="mt-1 text-sm text-slate-600">Bentornato su AstaAlimentare.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="login-email-input" autoComplete="email" />
          </div>
          <div>
            <div className="flex items-center justify-between"><Label htmlFor="password">Password</Label><Link to="/password-dimenticata" state={{ email }} className="text-xs font-semibold text-emerald-700 hover:underline" data-testid="login-forgot-link">Password dimenticata?</Link></div>
            <PasswordInput id="password" required value={password} onChange={e => setPassword(e.target.value)} testId="login-password-input" autoComplete="current-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full ga-btn-primary rounded-full" data-testid="login-submit-button">
            {loading ? "Accesso..." : "Accedi"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-slate-600 text-center">
          Nuovo su AstaAlimentare? <Link to="/registrazione" className="font-semibold text-slate-900 hover:underline" data-testid="login-to-register-link">Crea un account</Link>
        </div>
      </div>
    </div>
  );
}
